import React, { useEffect, useState } from "react"; 
import 'react-datalist-input/dist/styles.css'; 
import { URL, SAVEUPDATEREFERENCE } from "../paths";
import { fetchData } from "../../hooks/fetch/const_fetch";
import { getUserID, getUserName, getUserEntityIsEmployee } from "../datainfo/dto"; 
import Loader from "../loader/loader";  
const ModalRechazarPdf=({intCusDocId, estatus, strreferencia="sin referencia", mode, ConsultarDocumentosUsuario,  Mensaje, evtconfirmar, closeRechazarPdf,closeMostrarPdf})=>{// ConsultarDocumentosUsuario, Mensaje, setIsLoading, isOpenSubirDocumento, OpenSubirDocumento, closeModal})=>{
    const [motivorechazo,setMotivoRechazo] = useState("");
    const [validamotivorechazo,setValidaMotivoRechazo] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const RechazarPdf = async(intCusDocId)=>{
        try { 
            setIsLoading(true); 
            
            if(motivorechazo.trim().length <= 0 || motivorechazo.trim() === ""){
                Mensaje("Debe asignar un motivo de rechazo del documento.", "error", "top-center", 5000);
                setValidaMotivoRechazo("is-invalid");
                setIsLoading(false); 
                return;    
            }

            if(intCusDocId <= 0){
                Mensaje("El documento no tienen un identificador asignado.", "error", "top-center", 2500);
                setIsLoading(false); 
                return;
            }else{
                const dto = {   
                    "intMode":5,
                    "intUserId":getUserID(),
                    "strUserName":getUserName(),
                    "ref":{
                        "intCusDocId": intCusDocId,
                        "strReason": motivorechazo,
                    } 
                }  
                const url = URL+SAVEUPDATEREFERENCE; 
                const myHeaders = new Headers();
                myHeaders.append("Content-Type",  'application/json'); 
                const resultado =  await fetchData(url, 'POST', myHeaders, dto); 
                if(resultado.code === 0){ 
                    setIsLoading(false);
                    if(resultado.code === 0){ 
                        Mensaje(resultado.msg, "success", "top-center", 4000);
                        closeMostrarPdf();
                        closeRechazarPdf();
                    }else{
                        Mensaje(resultado.msg, "warning", "top-center", 4000);
                    }
                    ConsultarDocumentosUsuario();
                    
                }else{
                    Mensaje(resultado.msg,"info","top-center",5000);
                    setIsLoading(false); 
                }
            }
             
        }catch (error) {
            setIsLoading(false);
            Mensaje("Error al hacer la solicitud - RechazarPdf(), ERROR: "+error.message ,"error","top-center");
        }
    } 
 
    const handleMotivoRechazo=(evt)=>{ 
        setMotivoRechazo("");
        
        if(evt.target.value.trim().length === 0 ){
            setMotivoRechazo("");
            setValidaMotivoRechazo("");
        }
        else if(evt.target.value.trim().length > 0 ){
            setMotivoRechazo(evt.target.value);
            setValidaMotivoRechazo("is-valid");
        }else{
            setValidaMotivoRechazo("is-invalid");
        }
        
    }
  

    return(
        <>
        {isLoading?<Loader />:<></>}         
        <div className="modal-body"> 
            <div className="row">
                <p className="">{`¿DESEA RECHAZAR LA REFERENCIA`} <span className="fw-bold">{strreferencia}</span>.</p> 
            </div>    
            <div className="row mx-3">
                    <label className="mx-0 px-0">MOTIVO DEL RECHAZO:</label>
                    <textarea className={`form-control ${validamotivorechazo}`} minLength={10} maxLength={150} value={motivorechazo} onChange={(evt)=>{handleMotivoRechazo(evt)}} placeholder="INTRODUZCA UN MOTIVO DE RECHAZO" />
            </div>
        </div>
        <div className="modal-footer p-0">
                <div className="row  p-0">
                <div>
                    <button className="btn bg-danger text-white fw-bold float-end mx-1" onClick={()=>{RechazarPdf(intCusDocId)}} >RECHAZAR DOCUMENTO</button>
                    <button className="btn bg-primary text-white fw-bold float-end mx-1" onClick={closeRechazarPdf}>CANCELAR</button>
                </div>
            </div>    
        </div>    
        </>
    )
}

export default ModalRechazarPdf; 